import React from 'react';
import uuid from 'uuid-random';
import { useTranslate } from 'hooks/useTranslate';
import { styled } from '@mui/system';
import SortComponent from 'pages/Professions/components/Sort';

const FiltersWrapper = styled('div')(() => ({
  paddingBottom: 20,
  paddingTop: 20
}));

const Filters = ({ actions, sort }) => {
  const t = useTranslate('Posts');
  const [key] = React.useState(uuid());

  const sortValues = React.useMemo(
    () => [
      {
        column: 'title',
        direction: 'asc',
        name: t('ByName')
      },
      {
        column: 'viewsCount',
        direction: 'desc',
        name: t('ByPopularity')
      }
    ],
    [t]
  );

  return (
    <FiltersWrapper key={key}>
      <SortComponent actions={actions} sort={sort} sortValues={sortValues} />
    </FiltersWrapper>
  );
};

export default Filters;
